import React from 'react';
import { Box, ListItem } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Heading from '@/components/Heading';
import Text from '@/components/Text';
import Offer from '../../propTypes/Offer';
import RoomType from '../../propTypes/RoomType';
import htmlToReact from '../../utils/htmlToReact';
import ListWithDividers from '../ListWithDividers';
import Modal from '../Modal';
import TickedList from '../TickedList';

const RoomInformationModal = ({ close, roomType, offer }) => {
  const renderInclusions = (inclusions) => (
    <>
      <Heading.h6>Inclusions:</Heading.h6>
      <TickedList mt="3">
        {inclusions.map((inclusion) => (
          <ListItem data-testid="INCLUSION" key={inclusion.name} pl="2" mb="2">
            {inclusion.name}
          </ListItem>
        ))}
      </TickedList>
    </>
  );

  return (
    <Modal size="lg" onClose={() => close()}>
      <Modal.Header>Room information</Modal.Header>
      <Modal.Body>
        <Heading.h4 data-testid="ROOM_TYPE">{roomType.name}</Heading.h4>
        <Box data-testid="ROOM_DESCRIPTION" color="text.body" mt="2">
          <Text>{htmlToReact(roomType.description)}</Text>
        </Box>
        <Box mt="4">
          {offer && renderInclusions(offer.inclusions)}
          <Heading.h6>Room facilities:</Heading.h6>
          <ListWithDividers items={roomType.facilities} />
        </Box>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

RoomInformationModal.propTypes = {
  close: PropTypes.func.isRequired,
  roomType: PropTypes.shape(RoomType).isRequired,
  offer: PropTypes.shape(Offer),
};

export default RoomInformationModal;
